import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectCenterGitbook from "./routes/SubjectCenterGitbook";
export default store => ({
  path: "subject-center",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "subject-center" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [SubjectCenterGitbook(store)],
});
